import React, {useState, useEffect} from 'react';
import {View, StyleSheet, Text, ActivityIndicator} from 'react-native';
import {
   primaryState50,
   primaryState800,
   FONT_FAMILY_SEMI_BOLD,
   primaryColor500,
} from './utils';

const ThreeDotsLoaderWindows = props => {
   // const [dotOne] = useState(new Animated.Value(0));
   // const [dotTwo] = useState(new Animated.Value(0));
   // const [dotThree] = useState(new Animated.Value(0));

   return (
      <View style={{justifyContent: 'center', alignItems: 'center', flex: 1}}>
         <View style={styles.CircleShape}>
            <View style={styles.container}>
               <ActivityIndicator size={'large'} color={primaryColor500} />
            </View>
         </View>
         <Text
            style={{
               fontSize: 20,
               color: primaryState800,
               fontWeight: '600',
               fontFamily: FONT_FAMILY_SEMI_BOLD,
               marginTop: -5,
            }}>
            {props.title}
         </Text>
      </View>
   );
};

const styles = StyleSheet.create({
   container: {
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      flex: 1,
   },
   dot: {
      width: 14,
      height: 14,
      marginHorizontal: 4,
      backgroundColor: 'blue',
   },
   CircleShape: {
      width: 120,
      height: 120,
      borderRadius: 120 / 2,
      //margin: 24,
      marginHorizontal: 24,
      marginBottom: 24,
   },
});

export default ThreeDotsLoaderWindows;
